import { Injectable } from '@angular/core';
import {MessageService} from "primeng/api";
import {TranslocoService} from "@jsverse/transloco";
import {Message} from "primeng/api/message";



@Injectable({
  providedIn: 'root'
})
export class MessageUtilsService {

  constructor(private messageService: MessageService, private translateService: TranslocoService) {}

  public pushMessage(message: Message) {
    console.log(message);
    this.messageService.add(message);
  }

  public push(severity: string, summary?: string, detail?: string) {
    summary = summary || 'message.summary.' + severity;
    detail = detail || 'message.detail.' + severity;

    this.pushMessage({
      severity: severity,
      summary: this.translateService.translate(summary),
      detail: this.translateService.translate(detail),
    });
  }

  public static readonly Severity = { success: 'success', info: 'info' , warning: 'warn' , denied: 'denied', danger: 'danger' , error: 'danger' , secondary: 'secondary' , contrast: 'contrast'};

}





